module.exports = __webpack_public_path__ + "img/01.cd57fb70.png";